<template>
  <div id="app" class="container section">
    <h2 class="title">zion board 過去ログ</h2>
    <transition name="fade" mode="out-in">
      <router-view></router-view>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'app'
}
</script>

<style lang="scss" src="./assets/sass/app.scss">

</style>



// WEBPACK FOOTER //
// src/App.vue